import { render, staticRenderFns } from "./VehicleRecursionTree.vue?vue&type=template&id=620a4405&scoped=true"
import script from "./VehicleRecursionTree.vue?vue&type=script&lang=js"
export * from "./VehicleRecursionTree.vue?vue&type=script&lang=js"
import style0 from "./VehicleRecursionTree.vue?vue&type=style&index=0&id=620a4405&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a4405",
  null
  
)

export default component.exports